document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".variant-options").forEach((optionSet) => {
        optionSet.addEventListener("click", function (event) {
        const variant = event.target.closest(".variant-size");
        
        if (variant) {
          event.preventDefault();
          event.stopPropagation();
          
          // Remove 'selected' class from all variants and add to the clicked one
          this.querySelectorAll(".variant-size").forEach((el) => el.classList.remove("selected"));
          variant.classList.add("selected");
          
          // Update value of selected variant id in the keeper of only same card
          const variantIdInput = this.closest(".pdp-scent-content")?.querySelector(
            `.variant-id-keeper`
          );
          
          if (variantIdInput) {
            variantIdInput.value = variant.dataset.variantId;
          } else {
            console.warn("Variant ID input element not found.");
          }
        }
      });
    });
      

  document.querySelectorAll(".cus-quick-add-cta").forEach((button) => {
    button.addEventListener("click", async function (event) {
      event.preventDefault();
      event.stopPropagation(); // Prevents bubbling up to parent elements
      const loader = this.querySelector(".loading__spinner");
      loader.classList.remove("hidden");

      const siblingVariantIdKeeper =
        this.parentElement.querySelector(".variant-id-keeper");
      if (siblingVariantIdKeeper) {
        // Do something with siblingVariantIdKeeper
        const CurrentVariantId = siblingVariantIdKeeper.value;
        await addToCart(CurrentVariantId);
      }

      setTimeout(() => {
        loader.classList.add("hidden");
      }, 2000);
    });
  });
});
